<template>
  <a-form-item name="entity-prompt">
    <template #label>
      <span class="label">
        <strong>Cuéntanos sobre negocio</strong>

        <span class="label ai">
          <AISparksIcon /> <AIText>{{ CompanyName }} AI</AIText>
        </span>
      </span>
    </template>

    <p class="info">Esto ayudará a la inteligencia artificial a conocer más sobre ustedes.</p>

    <a-textarea
      :value="value"
      :autosize="{ minRows: 5, maxRows: 5 }"
      placeholder="Escribir aquí..."
      showCount
      :maxlength="1000"
      @update:value="emit('update:value', $event)"
    />
  </a-form-item>

  <a-form-item name="keywords">
    <template #label>
      <p style="font-weight: 400">
        <span>Palabras o frases clave que describan tu empresa</span>
        <a-tooltip title="Agrega nuevas palabras o frases haciendo click en “Enter”. ">
          <InfoCircleOutlined style="margin-left: 5px" />
        </a-tooltip>
      </p>
    </template>

    <a-select
      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      :value="keywords"
      mode="tags"
      :token-separators="[',']"
      placeholder="Escribir aquí"
      @update:value="emit('update:keywords', $event)"
    />
  </a-form-item>
</template>

<script setup lang="ts">
import AISparksIcon from "@/app/integrations/components/icons/AISparksIcon.vue";
import AIText from "@/app/integrations/components/labels/AIText.vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { CompanyName } from "@/app/shared/utils/constants";

defineProps<{ value: string; keywords: string[] }>();

const emit = defineEmits<{
  "update:value": [value: string];
  "update:keywords": [keywords: string[]];
}>();
</script>

<style scoped lang="sass">
p
  margin: 0

.info
  color: $text-primary

.label
  display: flex
  align-items: center
  gap: 2px
  color: $text-primary

  .ai
    margin-left: 6px
</style>
